export default __webpack_public_path__ + "static/media/argentan15.e3b5b1fe.jpg";